/* 司法确认详情 */
import Vue from 'vue';
import {queryJudicialInfoByBseId, genId} from '@/assets/js/api';
import {amount_format_yuan, accMul} from '@/assets/js/utils';
import * as utils from '@/assets/js/utils';

const rule_evidence = {
  '54': {
    show: ['1', '2'],
    required: false
  },
  '51': {
    show: ['2'],
    required: false
  },
  '52': {
    show: ['2'],
    required: false
  },
  '53': {
    show: ['2'],
    required: false
  },
  '55': {
    show: ['2'],
    required: false
  },
  '99': {
    show: ['1', '2'],
    required: false
  },
};

export default {
  state: {
    bseId: '',
    rulesConfig: {},
    // 基础信息
    base: {},
    caseAudits: [],
    // 关联非诉调解信息
    caseJudicialConfirmationDto: {},
    naturalPersonOrPlaintiffList: [],
    // 材料
    evidenceMap: {},
    fileDtoMap: {},
    materialFileMap: {},
  },
  getters: {
    params: (state) => {
      return {
        // 基础信息
        base: {
          ...state.base,
          bseQfkjzrq: accMul(Number(String(state.base.bseQfkjzrq).replace(/\,|\，/g, '')), 100)
        },
        caseJudicialConfirmationDto: {signTime: state.base.signTime},
        naturalPersonOrPlaintiffList: state.naturalPersonOrPlaintiffList,
        evidenceMap: state.evidenceMap,
        fileDtoMap: state.fileDtoMap,
        materialFileMap: state.materialFileMap,
      };
    },
    // 身份证明材料
    identificationFiles: (state) => {
      const data = state.naturalPersonOrPlaintiffList;
      const fileMap = state.materialFileMap;
      return data.reduce((result, person) => {
        const {
          pltId, type, personId, personName, pltUnit
        } = person;
        const id = type == 1 ? personId : pltId;
        const name = (type == 1 ? personName : pltUnit) || '--';
        result[`${id}`] = {
          owner: {id, name},
          type: {type},
          files: fileMap[id] || {}
        };
        if (person.mediateAgents) {
          person.mediateAgents.forEach(agent => {
            const {
              agtName, agtId, agtType
            } = agent;
            const name = agtName || '--';
            result[agtId] = {
              owner: {id: agtId, name},
              type: {type, agtType, isAgt: true},
              files: fileMap[agtId] || {}
            };
          });
        }
        return result;
      }, {});
    },
    // 诉讼材料
    litigationFiles: (state) => {
      const data = state.naturalPersonOrPlaintiffList;
      const fileMap = state.materialFileMap;
      return data.reduce((result, person) => {
        const {
          pltId, type, personId, personName, pltUnit
        } = person;
        const id = type == 1 ? personId : pltId;
        const name = (type == 1 ? personName : pltUnit) || '--';
        if (type == 1) {
          result[`${id}`] = {
            owner: {id, name},
            type: {type},
            files: fileMap[id] || {}
          };
        }
        if (person.mediateAgents) {
          person.mediateAgents.forEach(agent => {
            const {
              agtName, agtId, agtType
            } = agent;
            const name = agtName || '--';
            result[agtId] = {
              owner: {id: agtId, name},
              type: {type, agtType, isAgt: true},
              files: fileMap[agtId] || {}
            };
          });
        }
        return result;
      }, {});
    },
    // 证据材料
    evidenceObj: (state) => {
      const data = state.naturalPersonOrPlaintiffList;
      const fileMap = state.evidenceMap;
      return data.reduce((result, person) => {
        const {
          pltId, type, personId, personName, pltUnit
        } = person;
        const id = type == 1 ? personId : pltId;
        const name = (type == 1 ? personName : pltUnit) || '--';
        result[`${id}`] = {
          owner: {id, name},
          type: {type},
          files: fileMap[id] || {}
        };
        if (person.mediateAgents) {
          person.mediateAgents.forEach(agent => {
            const {
              agtName, agtId, agtType
            } = agent;
            const name = agtName || '--';
            result[agtId] = {
              owner: {id: agtId, name},
              type: {type, agtType, isAgt: true},
              files: fileMap[agtId] || {}
            };
          });
        }
        return result;
      }, {});
    }
  },
  mutations: {
    SET_BSE_ID: (state, bseId) => {
      state.bseId = bseId;
    },
    QUERY_JUDICIAL_INFO: (state, _data) => {
      state.caseAudits = _data.caseAudits || [];
      state.caseJudicialConfirmationDto = _data.caseJudicialConfirmationDto || {};
      state.base = {
        applicantIdentity: '',
        ..._data.base,
        signTime: _data.caseJudicialConfirmationDto.signTime || '',
        bseQfkjzrq: amount_format_yuan(_data.base.bseQfkjzrq)
      };
      state.mediateAgents = _data.mediateAgents || [];
      state.evidenceMap = _data.evidenceMap || {};
      state.fileDtoMap = _data.fileDtoMap || {};
      state.materialFileMap = _data.materialFileMap || {};
      state.naturalPersonOrPlaintiffList = _data.naturalPersonOrPlaintiffList.map(item => {
        const mediateAgents = item.mediateAgents || [];
        const id = item.personId || item.pltId;
        const address = item.address || {};
        return {
          personName: '',
          idType: '',
          idNumber: '',
          encryption_idNumber: utils.encryptionIdNumber(item.idNumber),
          sex: '',
          age: '',
          mobileNo: '',
          encryption_mobileNo: utils.encryptionPhone(item.mobileNo),
          profession: '',
          unitName: '',
          email: '',
          domicileAddress: '',
          deliveryAddress: '',
          permanentAddress: '',

          currentAddress: '',
          pltUnit: '',
          pltLicenceType: '',
          pltLicenceNumber: '',
          pltUnitType: '',
          pltAddress: '',
          pltContactInfo: '',
          pltLeaderName: '',
          pltLeaderIdType: '',
          pltLeaderIdNumber: '',
          encryption_pltLeaderIdNumber: utils.encryptionIdNumber(item.pltLeaderIdNumber),
          pltLeaderJob: '',
          pltLeaderPhone: '',
          encryption_pltLeaderPhone: utils.encryptionPhone(item.pltLeaderPhone),
          pltLeaderTelephone: '',
          extendFields: {
            isAppointDelivery: '',
          },
          ...item,
          address: {
            adsBseId: state.bseId,
            relatedUserId: id,
            adsName: '',
            adsPhone: '',
            adsAddress: '',
            adsContact: '',
            email: '',
            ...address
          },
          pltId: id,
          personId: id,
          mediateAgents: mediateAgents.map(mediateAgent => {
            const mediateAgentAddress = mediateAgent.address || {};
            return {
              agtType: '',
              agtName: '',
              agtIdType: '',
              agtIdNumber: '',
              encryption_agtIdNumber: utils.encryptionIdNumber(mediateAgent.agtIdNumber),
              agentSex: '',
              agtPhone: '',
              encryption_agtPhone: utils.encryptionPhone(mediateAgent.agtPhone),
              agtLawyerType: '',
              agtOffice: '',
              lawRegistrAddress: '',
              agtLicnumber: '',
              ...mediateAgent,
              address: {
                adsBseId: state.bseId,
                relatedUserId: mediateAgent.agtId,
                adsName: '',
                adsPhone: '',
                adsAddress: '',
                curAddress: '',
                email: '',
                adsContact: '',
                ...mediateAgentAddress
              },
            };
          }),
          nation: String(item.nation || ''),
          pltContactType: String(item.pltContactType || ''),
        };
      });
    },
    ADD_APPLICANT: (state, _data) => {
      state.naturalPersonOrPlaintiffList.push(_data);
    },
    DEL_APPLICANT: (state, index) => {
      state.naturalPersonOrPlaintiffList.splice(index, 1);
    },
    // 申请人材料集合
    // 上传分多种情况
    // 1 直接添加 2 点击上传
    // 点击上传分为
    // 1 必填材料 2 非必填材料
    UPDATE_FILE_OWNER: (state, data) => {
      const {
        ownerId, fileType, currentData
      } = data.data;
      const {name} = data;
      // 如果没有所属人，手动增加一个
      const owner = state[name][ownerId];
      if (!owner) {
        Vue.set(state[name], ownerId, {});
      }
      // 如果没有材料，手动增加一个
      const files = state[name][ownerId][fileType];
      if (!files) {
        Vue.set(state[name][ownerId], fileType, []);
      }
      // 判断是添加还是上传
      if (currentData) {
        // 判断当前上传的材料是否是必填
        if (currentData.required) {
          // 当前行是否有材料
          if (state[name][ownerId][fileType][0]) {
            state[name][ownerId][fileType][0].fileName = data.data.fileName;
            state[name][ownerId][fileType][0].saveId = data.data.saveId;
          } else {
            state[name][ownerId][fileType].push(data.data);
          }
        } else {
          state[name][ownerId][fileType].map((item, index) => {
            if (item.saveId === currentData.saveId) {
              state[name][ownerId][fileType][index].fileName = data.data.fileName;
              state[name][ownerId][fileType][index].saveId = data.data.saveId;
            }
          });
        }
      } else {
        state[name][ownerId][fileType].push(data.data);
      }
    },
    DEL_FILE_OWNER: (state, data) => {
      const {
        ownerId, fileType, saveId, required
      } = data.data;
      const {name} = data;
      state[name][ownerId][fileType].forEach((item, index) => {
        if (item.saveId === saveId) {
          if (required) {
            state[name][ownerId][fileType][index].fileName = '';
            state[name][ownerId][fileType][index].saveId = '';
          } else {
            state[name][ownerId][fileType].splice(index, 1);
          }
        }
      });
    },
    UPDATE_FILE: (state, data) => {
      const {
        fileType, isNew
      } = data.data;
      const {name} = data;
      // 如果没有材料，手动增加一个
      const files = state[name][fileType];
      if (!files) {
        Vue.set(state[name], fileType, []);
      }
      if (isNew || !state[name][fileType][0]) {
        state[name][fileType].push(data.data);
      } else {
        state[name][fileType][0].fileName = data.data.fileName;
        state[name][fileType][0].saveId = data.data.saveId;
      }
    },
    DEL_FILE: (state, data) => {
      const {
        fileType, saveId, required
      } = data.data;
      const {name} = data;
      state[name][fileType].forEach((item, index) => {
        if (item.saveId === saveId) {
          if (required) {
            state[name][fileType][index].fileName = '';
            state[name][fileType][index].saveId = '';
          } else {
            state[name][fileType].splice(index, 1);
          }
        }
      });
    },
    QUERY_RULES_CONFIG: (state, data) => {
      state.rulesConfig = data;
    },
    ENCRYPTION_DATA(state, isEncryption){
      if (isEncryption) {
        state.naturalPersonOrPlaintiffList.forEach(item => {
          item.encryption_mobileNo = utils.encryptionPhone(item.mobileNo);
          item.encryption_idNumber = utils.encryptionIdNumber(item.idNumber);
          item.encryption_pltLeaderPhone = utils.encryptionPhone(item.pltLeaderPhone);
          item.encryption_pltLeaderIdNumber = utils.encryptionIdNumber(item.pltLeaderIdNumber);
        });
      } else {
        state.naturalPersonOrPlaintiffList.forEach(item => {
          item.encryption_mobileNo = item.mobileNo;
          item.encryption_idNumber = item.idNumber;
          item.encryption_pltLeaderPhone = item.pltLeaderPhone;
          item.encryption_pltLeaderIdNumber = item.pltLeaderIdNumber;
        });
      }
    },
  },
  actions: {
    QueryRulesConfig({commit}) {
      commit('QUERY_RULES_CONFIG', {
        base: {bseQfkjzrq: {required: false, disabled: false},},
        // 立案审核信息
        // 申请人信息
        plaintiff: {
          disabled: false,
          personName: {required: true, disabled: false},
          idType: {required: true, disabled: false},
          idNumber: {required: true, disabled: false},
          age: {required: true, disabled: false},
          sex: {required: true, disabled: false},
          nation: {required: false, disabled: false},
          mobileNo: {required: true, disabled: false},
          profession: {required: false, disabled: false},
          unitName: {required: false, disabled: false},
          email: {required: false, disabled: false},
          domicileAddress: {required: false, disabled: false},
          deliveryAddress: {required: false, disabled: false},
          permanentAddress: {required: false, disabled: false},
          isAppointDelivery: {required: false, disabled: false},
          currentAddress: {required: true, disabled: false},
          pltUnit: {required: true, disabled: false},
          pltLicenceType: {required: true, disabled: false},
          pltLicenceNumber: {required: true, disabled: false},
          pltEnterpriseType: {required: false, disabled: false},
          pltAddress: {required: true, disabled: false},
          pltContactType: {required: true, disabled: false},
          pltContactInfo: {required: false, disabled: false},
          pltLeaderName: {required: true, disabled: false},
          pltLeaderIdType: {required: true, disabled: false},
          pltLeaderIdNumber: {required: true, disabled: false},
          pltLeaderJob: {required: false, disabled: false},
          pltLeaderPhone: {required: true, disabled: false},
          pltLeaderTelephone: {required: false, disabled: false},
          address: {
            adsName: {required: false, disabled: false},
            adsPhone: {required: false, disabled: false},
            adsAddress: {required: false, disabled: false},
            adsContact: {required: false, disabled: false},
            email: {required: false, disabled: false},
          },
        },
        // 代理人信息
        agent: {
          disabled: false,
          agtType: {required: true, disabled: false},
          agtName: {required: true, disabled: false},
          agtIdNumber: {required: true, disabled: false},
          agtPhone: {required: true, disabled: false},
          agtMail: {required: true, disabled: false},
          agtDeliveryAddress: {required: true, disabled: false},
          agtLawyerType: {required: false, disabled: false},
          agtOffice: {required: true, disabled: false},
          lawRegistrAddress: {required: false, disabled: false},
          agtLicnumber: {required: true, disabled: false},
          agentSex: {required: true, disabled: false},
          agtIdType: {required: true, disabled: false},
          address: {
            adsName: {required: true, disabled: false},
            adsPhone: {required: true, disabled: false},
            adsAddress: {required: true, disabled: false},
            adsContact: {required: false, disabled: false},
            email: {required: true, disabled: false},
            curAddress: {required: true, disabled: false},
          },
        },
        // 材料
        file: {
          canUpload: true, // 总的上传
        },
      });
    },
    QueryJudicialInfo({
      commit, state
    }, bseId) {
      return new Promise((resolve, reject) => {
        commit('SET_BSE_ID', bseId);
        queryJudicialInfoByBseId({bseId})
          .then(({
            code, data, msg
          }) => {
            if (code === 200) {
              commit('QUERY_JUDICIAL_INFO', data);
              resolve();
            } else {
              reject();
            }
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 添加申请人
    async AddApplicant({
      commit, state
    }) {
      const bseId = state.bseId;
      const id = await genId();
      commit('ADD_APPLICANT', {
        pltId: id.data,
        personId: id.data,
        pltBseId: bseId,
        mediateId: bseId,
        type: '1',
        personName: '',
        idType: '',
        idNumber: '',
        encryption_idNumber: '',
        sex: '',
        age: '',
        nation: '',
        mobileNo: '',
        encryption_mobileNo: '',
        profession: '',
        unitName: '',
        email: '',
        domicileAddress: '',
        deliveryAddress: '',
        permanentAddress: '',
        currentAddress: '',
        pltUnit: '',
        pltLicenceType: '',
        pltLicenceNumber: '',
        pltUnitType: '',
        pltAddress: '',
        pltContactType: '',
        pltContactInfo: '',
        pltLeaderName: '',
        pltLeaderIdType: '',
        pltLeaderIdNumber: '',
        encryption_pltLeaderIdNumber: '',
        pltLeaderJob: '',
        pltLeaderPhone: '',
        encryption_pltLeaderPhone: '',
        pltLeaderTelephone: '',
        address: {
          adsBseId: bseId,
          relatedUserId: id.data,
          adsName: '',
          adsPhone: '',
          adsAddress: '',
          adsContact: '',
          email: '',
        },
        mediateAgents: [],
        extendFields: {
          isAppointDelivery: '',
        }
      });
    },
    // 删除申请人
    async DelApplicant({commit}, data) {
      commit('DEL_APPLICANT', data);
    },
    UpdateFile({commit}, data) {
      if (data.name === 'fileDtoMap') {
        commit('UPDATE_FILE', data);
      } else {
        commit('UPDATE_FILE_OWNER', data);
      }
    },
    DelFile({commit}, data) {
      if (data.name === 'fileDtoMap') {
        commit('DEL_FILE', data);
      } else {
        commit('DEL_FILE_OWNER', data);
      }
    }
  }
};
